import React, { Component } from 'react';
import { Button, Card, FormControl, FormHelperText, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip } from '@mui/material';
import { Colors } from '../../../../../Styles/Colors';
import { DateTime } from "luxon";
import FilterListIcon from '@mui/icons-material/FilterList';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import RestAPIService from '../../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../../Utility/API/Serviceurls';
import { localGetItem } from '../../../../../Utility/Services/CacheProviderService';
import { DosageType } from '../../../../../Components/CommonFunctions/CommonFunctions';
import Dialog from '../../../../../Components/Dialog';
import Failed from "../../../../../Assets/Animation/Failed.gif";
import DatePicker from "../../../../../Components/DatePicker/DatePicker";
import { Trans, withTranslation } from 'react-i18next';

class SlowMovementDrugs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 0,
      rowsPerPage: 5,
      BrandNameSortOrder: 'asc',
      BrandNameSortIcon: 'none',
      LastBillDateSortOrder: 'asc',
      LastBillDateSortIcon: 'none',
      SlowMovementStock: [],
      DefaultSlowMovementStock: [],
      dialogBox: false,
      SearchText: "",
      dateFilter: 0,
      QueryFrmDte: "",
      QueryToDte: "",
      datePickerPop: false,
      pharmacyId: localGetItem("Pharmacy_Id")
    }
  }

  componentDidMount() {
    this.getSlowMovementDrugs();
  }

  getSlowMovementDrugs = () => {
    try {
      RestAPIService.getAll(Serviceurls.PHARMACY_REPORT_SlowMovement_Stock + `?pharmacy_id=${this.state.pharmacyId}&from_date=${this.state.QueryFrmDte}&to_date=${this.state.QueryToDte}`)
        .then(response => {
          this.setState({
            SlowMovementStock: response.data.data,
            DefaultSlowMovementStock: response.data.data
          })
        })
        .catch(e => {
          this.setState({ dialogBox: true, ErrorMsg: e.message });
          setTimeout(() => {
            this.setState({
              dialogBox: false
            })
          }, 3000)
        });
    }
    catch (e) {
      this.setState({ dialogBox: true, ErrorMsg: e.message });
      setTimeout(() => {
        this.setState({
          dialogBox: false
        })
      }, 3000)
    }
  }

  //  Mui table Pagination Functions --- starts

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  }

  //  Mui table Pagination Functions --- ends

  PopClose = () => {
    this.setState({
      datePickerPop: false,
      dateFilter: 0,
      QueryFrmDte: "",
      QueryToDte: "",
    }, () => this.getSlowMovementDrugs())
  }

  CustomDates = (FromDate, ToDate) => {
    this.setState({
      QueryFrmDte: FromDate,
      QueryToDte: ToDate,
      datePickerPop: false
    }, () => this.getSlowMovementDrugs())
  }

  dialogCloseFunction = () => {
    this.setState({
      dialogBox: false
    })
  }

  DateHelperText = () => {
    if (this.state.dateFilter === 0) {
      return " "
    }
    else if (this.state.dateFilter === 1) {
      return DateTime.now().toFormat('dd-MM-yyyy')
    }
    else if (this.state.dateFilter === 2) {
      return DateTime.now().minus({ days: 1 }).toFormat('dd-MM-yyyy')
    }
    else if (this.state.dateFilter === 3) {
      return `${DateTime.now().minus({ days: 7 }).toFormat('dd-MM-yyyy')}  to  ${DateTime.now().toFormat('dd-MM-yyyy')}`
    }
    else if (this.state.dateFilter === 4) {
      return `${DateTime.now().minus({ days: 30 }).toFormat('dd-MM-yyyy')}  to  ${DateTime.now().toFormat('dd-MM-yyyy')}`
    }
    else if (this.state.dateFilter === 5) {
      return this.state.QueryToDte === undefined ? null : `${this.state.QueryFrmDte.split("-").reverse().join("-")}  to  ${this.state.QueryToDte.split("-").reverse().join("-")}`
    }
  }

  render() {
    const { t } = this.props

    // Sorting Function   ==== starts
    const sorting = (col, SortOrder) => {
      if (SortOrder === "asc") {
        const Sorted = [...this.state.SlowMovementStock].sort((a, b) => {
          if (typeof (a[col]) == "string") {
            return a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1
          } else {
            return a[col] > b[col] ? 1 : -1
          }
        })
        this.setState({ SlowMovementStock: Sorted })

        if (col === "drug_name") {
          this.setState({ BrandNameSortOrder: 'desc', LastBillDateSortOrder: 'asc', BrandNameSortIcon: "asc", LastBillDateSortIcon: "none" })
        }
        else if (col === "last_bill_date") {
          this.setState({ LastBillDateSortOrder: 'desc', BrandNameSortOrder: 'asc', BrandNameSortIcon: 'none', LastBillDateSortIcon: 'asc', })
        }

      }
      else if (SortOrder === "desc") {
        const Sorted = [...this.state.SlowMovementStock].sort((a, b) => {
          if (typeof (a[col]) == "string") {
            return a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1
          } else {
            return a[col] < b[col] ? 1 : -1
          }
        })
        this.setState({ SlowMovementStock: Sorted })

        if (col === "drug_name") {
          this.setState({ BrandNameSortOrder: 'default', BrandNameSortIcon: "desc" })
        }
        else if (col === "last_bill_date") {
          this.setState({ LastBillDateSortOrder: 'default', LastBillDateSortIcon: "desc" })
        }
      }
      else if (SortOrder === "default") {
        this.setState({
          BrandNameSortIcon: 'none',
          BrandNameSortOrder: 'asc',
          LastBillDateSortIcon: "none",
          LastBillDateSortOrder: "asc",
          SlowMovementStock: this.state.DefaultSlowMovementStock
        })
      }
    }
    // Sorting Function   ==== ends


    //  Sorting Icons Change func === starts 
    const SortIcon = (sortType) => {
      if (sortType === "asc") {
        return <Tooltip disableInteractive placement='top' title={t("InAscendingOrder")}><KeyboardArrowUpIcon sx={{ color: Colors.SortIconColor }} id='eMed_sorting_icon' /></Tooltip>
      }
      else if (sortType === 'desc') {
        return <Tooltip disableInteractive placement='top' title={t("InDecendingOrder")}><KeyboardArrowDownIcon sx={{ color: Colors.SortIconColor }} id='eMed_sorting_icon' /></Tooltip>
      }
      else return <Tooltip disableInteractive placement='top' title={t("Sorting")}><FilterListIcon sx={{ color: Colors.SortIconColor }} id='eMed_sorting_icon' /></Tooltip>
    }

    //  Sorting Icons Change func === ends 


    //  filter table data based on search Text
    const filtereddata = this.state.SlowMovementStock.filter((data) => {
      return (
        (data.drug_name === null ? null : data.drug_name.toLowerCase().includes(this.state.SearchText.toLowerCase())) ||
        (data.drug_strength === null ? null : data.drug_strength.toLowerCase().includes(this.state.SearchText.toLowerCase())) ||
        (data.last_bill_date === null ? null : data.last_bill_date.includes(this.state.SearchText))
      );
    });

    //  Sorting Icons Change func === ends 

    const handleDate = () => {
      var today = DateTime.now().toFormat('yyyy-MM-dd')
      var yesterday = DateTime.now().minus({ days: 1 }).toFormat('yyyy-MM-dd')
      var startweek = DateTime.now().minus({ days: 7 }).toFormat('yyyy-MM-dd')
      var startmonth = DateTime.now().minus({ days: 30 }).toFormat('yyyy-MM-dd')

      if (this.state.dateFilter === 0) {
        this.setState({
          QueryFrmDte: "",
          QueryToDte: "",
        }, () => {
          this.getSlowMovementDrugs()
        })
      }
      else if (this.state.dateFilter === 1) {
        this.setState({
          QueryFrmDte: today,
          QueryToDte: today,
        }, () => {
          this.getSlowMovementDrugs()
        })

      }
      else if (this.state.dateFilter === 2) {
        this.setState({
          QueryFrmDte: yesterday,
          QueryToDte: yesterday,
        }
          , () => {
            this.getSlowMovementDrugs()
          })
      }
      else if (this.state.dateFilter === 3) {
        this.setState({
          QueryFrmDte: startweek,
          QueryToDte: yesterday,
        },
          () => {
            this.getSlowMovementDrugs()
          })
      }
      else if (this.state.dateFilter === 4) {
        this.setState({
          QueryFrmDte: startmonth,
          QueryToDte: yesterday,
        },
          () => {
            this.getSlowMovementDrugs()
          })
      }
      else if (this.state.dateFilter === 5) {
        this.setState({ datePickerPop: true })
      }
    }

    const handleChange = (event) => {
      this.setState({ dateFilter: event.target.value }, () => handleDate());
    };

    return (
      <div>
        <div className="eMed_page_header">
          <div id='eMed_table_name' style={{ color: Colors.TextColor }}>{t(this.props.menuName)}</div>
          <div id='eMed_tbl_filters'>
            <div>
              <FormControl id="eMed_tbl_datefilter">
                <InputLabel sx={{ color: Colors.TextColor }}>{t("SelectDate")}</InputLabel>
                <Select
                  sx={{ color: Colors.TextColor }}
                  size='small'
                  value={this.state.dateFilter}
                  label={t("SelectDate")}
                  onChange={handleChange}
                >
                  <MenuItem value={0}>{t("All")}</MenuItem>
                  <MenuItem value={1}>{t("Today")}</MenuItem>
                  <MenuItem value={2}>{t("Yesterday")}</MenuItem>
                  <MenuItem value={3}>{t("Lastweek")}</MenuItem>
                  <MenuItem value={4}>{t("LastMonth")}</MenuItem>
                  <MenuItem value={5} onClick={() => this.setState({ datePickerPop: true })}>{t("Custom")}</MenuItem>
                </Select>
                <FormHelperText id="eMed_form_helpertext">{this.DateHelperText()}</FormHelperText>
              </FormControl>
            </div>
            {this.state.SearchFieldOpen ?
              <div id="eMed_tbl_searchbox" >
                <TextField
                  size='small'
                  focused
                  onChange={(e) => this.setState({ SearchText: e.target.value })}
                  value={this.state.SearchText}
                  label={t("SearchHere")}
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <Tooltip disableInteractive title={t("Clear")} placement='top'><CloseIcon sx={{ color: Colors.ThemeColor }} onClick={() => { this.setState({ SearchText: '' }) }} /></Tooltip>
                    ),
                  }}
                />
              </div> : null}
            <Tooltip disableInteractive placement="top-start" title={this.state.SearchFieldOpen ? t("CloseSearch") : t("OpenSearch")}>
              <Button id="eMed_tbl_searchicon" variant='contained' style={{ backgroundColor: Colors.ThemeColor }} onClick={() => this.setState({ SearchFieldOpen: !this.state.SearchFieldOpen, CardOpen: false, SearchText: '' })} >
                {this.state.SearchFieldOpen ? <CloseIcon /> : <SearchIcon />}
              </Button>
            </Tooltip>
          </div>
        </div>
        <Card className='eMed_tbl_card' sx={{ bgcolor: Colors.TableCard }}>
          <TableContainer className='eMed_tbl_container'>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className='eMed_tbl_headwidth_small id="eMed_nonsticky_head"' sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}><div className='eMed_sortable_center' id="eMed_tbl_headtext">{t("S.No")}</div></TableCell>
                  <TableCell className='eMed_tbl_headwidth_large' sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}>
                    <div className=' eMed_sortable_name'>
                      <div id="eMed_tbl_headtext">{t("BrandName")}</div>
                      <div onClick={() => { sorting("drug_name", this.state.BrandNameSortOrder) }}>{SortIcon(this.state.BrandNameSortIcon)}</div>
                    </div>
                  </TableCell>
                  <TableCell className='eMed_tbl_headwidth_small' id="eMed_nonsticky_head" sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}><div className='eMed_sortable_center' id="eMed_tbl_headtext">{t("DosageType")}</div></TableCell>
                  <TableCell className='eMed_tbl_headwidth_small' id="eMed_nonsticky_head" sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}><div className='eMed_sortable_center' id="eMed_tbl_headtext">{t("Strength")}</div></TableCell>
                  <TableCell className='eMed_tbl_headwidth_large' id="eMed_nonsticky_head" sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}>
                    <div className=' eMed_sortable_center'>
                      <div id="eMed_tbl_headtext">{t("LastBillDate")}</div>
                      <div onClick={() => { sorting("last_bill_date", this.state.LastBillDateSortOrder) }}>{SortIcon(this.state.LastBillDateSortIcon)}</div>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              {filtereddata.length > 0 ? filtereddata.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                .map((data, index) => {
                  return (
                    <TableBody>
                      <TableRow>
                        <TableCell align='center' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>{index + 1}</TableCell>
                        <TableCell align='left' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>
                          {data.drug_name.length > 12 ?
                            <Tooltip placement="top" title={data.drug_name} disableInteractive>
                              <div id='eMed_tbl_bodytext'>{data.drug_name.slice(0, 12) + '...'}</div>
                            </Tooltip> : `${data.drug_name}`}
                        </TableCell>
                        <TableCell align='center' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>{DosageType(data.drug_type)} </TableCell>
                        <TableCell align='center' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>{data.drug_strength}</TableCell>
                        <TableCell align='center' id='eMed_tbl_bodytext' sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}>
                          <div id='eMed_tbl_bodytext'>{data.last_bill_date}</div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )
                }) :
                <div id='eMed_Norecords' style={{ color: Colors.TableHeaderTextColor }}>
                  {t("NoRecords")}
                </div>}
            </Table>
          </TableContainer>
          <TablePagination
            component='div'
            id="eMed_Table_Pagination"
            sx={{
              color: Colors.Pagination
            }}
            rowsPerPageOptions={[5, 10, 15]}
            count={filtereddata.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Card>
        {this.state.datePickerPop ? <DatePicker PopClose={this.PopClose} CustomDates={this.CustomDates} /> : null}
        {
          this.state.dialogBox ?
            <Dialog
              type={"Notification"}
              DialogClose={this.state.dialogBox}
              header={"Message"}
              content={this.state.ErrorMsg}
              icon={<img className="eMed_dilboxAnimations" alt="Warning" src={Failed} />}
              secondary={"Close"}
            /> : null
        }
      </div>
    )
  }
}
export default withTranslation()(SlowMovementDrugs);